<template>
  <v-dialog v-model="view_modal" max-width="600px" persistent>
    <v-card>
      <v-card-text>
        <v-container grid-list-mid>
          <v-layout wrap>
            <v-flex xs12 sm6 md4>
              <v-text-field type="number" v-model="num_people" label="Number of people*" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="service_location" label="Service location*" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 v-if="serviceFilters.round_trip">
              <v-select
                v-model="round_trip"
                :items="serviceFilters.round_trip"
                label="Round-trip*"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 v-if="serviceFilters.vehicles">
              <v-autocomplete
                v-model="vehicle_type"
                :items="serviceFilters.vehicles"
                label="Vehicle type*"
                required
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 v-if="serviceFilters.reservation_size">
              <v-autocomplete
                v-model="reservation_size"
                :items="serviceFilters.reservation_size"
                label="Reservation size*"
                required
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md4 v-if="serviceFilters.num_items">
              <v-text-field type="number" v-model="num_rooms" label="Number of rooms*" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 v-if="serviceFilters.num_plates">
              <v-text-field type="number" v-model="num_plates" label="Number of plates*" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 v-if="serviceFilters.food_type">
              <v-text-field type="text" v-model="food_type" label="Food Type*" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 v-if="serviceFilters.num_bodyguards">
              <v-text-field
                type="number"
                v-model="num_bodyguards"
                label="Number of bodyguards"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 v-if="serviceFilters.square_footage">
              <v-text-field type="number" v-model="sqr_foot" label="Square footage*" required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="special_req" label="Special requests"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-dialog
                ref="dialog"
                persistent
                v-model="modal"
                lazy
                full-width
                class="mt-3"
                width="330px"
                :return-value.sync="date"
              >
                <v-text-field
                  slot="activator"
                  label="Start & End Dates"
                  v-model="format_date"
                  :rules="[v => !!v || 'Event date is required']"
                  required
                  multiple
                  prepend-icon="event"
                  width="330px"
                  readonly
                ></v-text-field>
                <v-date-picker
                  width="330px"
                  multiple
                  v-model="event.date"
                  no-title
                  scrollable
                  @input="save_date()"
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs11 sm5>
              <v-text-field
                v-model="stime"
                @click="startTime=true"
                label="Start Time"
                prepend-icon="access_time"
                readonly
              ></v-text-field>
              <v-dialog
                ref="start_dialog"
                v-model="startTime"
                :return-value.sync="stime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-time-picker v-if="startTime" v-model="stime">
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="startTime = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.start_dialog.save(stime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs11 sm5>
              <v-text-field
                v-model="etime"
                @click="endTime=true"
                label="End Time"
                prepend-icon="access_time"
                readonly
              ></v-text-field>
              <v-dialog
                ref="end_dialog"
                v-model="endTime"
                :return-value.sync="etime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-time-picker v-if="endTime" v-model="etime">
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="endTime = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.end_dialog.save(etime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close_modal">Close</v-btn>
        <v-btn
          color="indigo"
          @click.native="add_to_cart"
          class="next-button white--text"
          :disabled="!service_data_valid"
          v-if="!this.updateService"
        >Add to Cart</v-btn>
        <v-btn
          color="indigo"
          @click.native="update_service"
          class="next-button white--text"
          :disabled="!service_data_valid"
          v-else
        >Update</v-btn>
        <v-btn
          color="indigo"
          @click.native="go_custom"
          class="next-button white--text"
          :disabled="!service_data_valid"
        >Next</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    serviceFilters: {
      type: Object,
      required: true
    },
    card: {
      type: Object,
      required: true
    },
    updateService: {
      type: Object,
      required: false
    }
  },
  mounted() {
    this.checkIfUpdate();
  },
  data: () => {
    return {
      stime: null,
      startTime: false,
      etime: null,
      endTime: false,
      showModal: false,
      num_people: "",
      service_location: "",
      special_req: "",
      round_trip: "",
      vehicle_type: "",
      reservation_size: "",
      num_rooms: "",
      num_bodyguards: "",
      num_plates: "",
      food_type: "",
      sqr_foot: "",
      service: {
        input: {},
        service_info: {},
        card: {}
      },
      modal: false,
      date: null,
      event: {
        title: "",
        location: "",
        description: "",
        date: [],
        services: [],
        special: ""
      }
    };
  },
  methods: {
    checkIfUpdate() {
      if (this.updateService) {
        if (this.updateService.input.num_people)
          this.num_people = this.updateService.input.num_people;
        if (this.updateService.input.service_location)
          this.service_location = this.updateService.input.service_location;
        if (this.updateService.input.special_req)
          this.special_req = this.updateService.input.special_req;
        if (this.updateService.input.round_trip)
          this.round_trip = this.updateService.input.round_trip;
        if (this.updateService.input.vehicle_type)
          this.vehicle_type = this.updateService.input.vehicle_type;
        if (this.updateService.input.reservation_size)
          this.reservation_size = this.updateService.input.reservation_size;
        if (this.updateService.input.num_rooms)
          this.num_rooms = this.updateService.input.num_rooms;
        if (this.updateService.input.num_plates)
          this.num_plates = this.updateService.input.num_plates;
        if (this.updateService.input.food_type)
          this.food_type = this.updateService.input.food_type;
        if (this.updateService.input.num_bodyguards)
          this.num_bodyguards = this.updateService.input.num_bodyguards;
        if (this.updateService.input.sqr_foot)
          this.sqr_foot = this.updateService.input.sqr_foot;
        if (this.updateService.input.dates)
          this.event.date = this.updateService.input.dates
            .split(" ")
            .filter(el => el !== "to");
      }
    },
    save_date() {
      if (this.event.date.length >= 3) this.event.date.shift();
    },
    save_info() {
      this.service.id = this.updateService ? this.updateService.id : Math.random().toString(36).substring(7);

      this.service.service_info = this.serviceFilters.service_info;
      this.service.service_info.service_fee =
        (this.serviceFilters.service_info.cost +
          this.serviceFilters.service_info.estimate) *
        0.25;
      this.service.service_info.total =
        this.serviceFilters.service_info.cost +
        this.serviceFilters.service_info.estimate +
        this.serviceFilters.service_info.service_fee;

      this.service.input.dates = this.format_date;
      this.service.input.num_people = this.num_people;
      this.service.input.service_location = this.service_location;
      this.service.input.special_req = this.special_req;
      if (this.round_trip) {
        this.service.input.round_trip = this.round_trip;
      }
      if (this.vehicle_type) {
        this.service.input.vehicle_type = this.vehicle_type;
      }
      if (this.reservation_size) {
        this.service.input.reservation_size = this.reservation_size;
      }
      if (this.num_rooms) {
        this.service.input.num_rooms = this.num_rooms;
      }
      if (this.num_plates) {
        this.service.input.num_plates = this.num_plates;
      }
      if (this.food_type) {
        this.service.input.food_type = this.food_type;
      }
      if (this.num_bodyguards) {
        this.service.input.num_bodyguards = this.num_bodyguards;
      }
      if (this.sqr_foot) {
        this.service.input.sqr_foot = this.sqr_foot;
      }

      this.service.card = this.card;
      this.service.service_filters = this.serviceFilters;
    },
    add_to_cart() {
      this.save_info();

      this.$store
        .dispatch("addServiceToCart", this.service)
        .then(() => {
          this.showSuccess(`Successfully added service to shopping cart`);
          this.$router.push("home");
        })
        .catch(error => {
          this.showError(error);
        });
      // need to connect api for response
      this.showSuccess(`Successfully added service to shopping cart`);
      this.$router.push("home");
    },
    update_service() {
      this.save_info();
      this.$store
        .dispatch("updateServiceInCart", this.service)
        .then(() => {
          this.showSuccess(`Successfully updated service`);
        })
        .catch(error => {
          this.showError(error);
        });
      this.showSuccess(`Successfully updated service`);
    },
    go_custom() {
      this.save_info();
      this.$router.push({
        name: "create-event",
        params: { service: this.service.service_info }
      });
    },
    clear_fields() {
      this.num_people = "";
      this.service_location = "";
      this.special_req = "";
      this.round_trip = "";
      this.vehicle_type = "";
      this.reservation_size = "";
      this.num_rooms = "";
      this.num_bodyguards = "";
      this.sqr_foot = "";
    },
    close_modal() {
      this.showModal = false;
      this.$store
        .dispatch("handleModal", this.showModal)
        .then(() => {
          this.clear_fields();
        })
        .catch(error => {
          this.showError(error);
        });

      this.clear_fields();
    }
  },
  computed: {
    format_date() {
      let num_dates = this.event.date.length;
      if (num_dates == 2)
        return `${this.event.date[0]} to ${this.event.date[1]}`;
      else return this.event.date;
    },
    service_data_valid() {
      // need to be improved
      return this.event.date.length == 2 && this.service;
    },
    view_modal() {
      return this.$store.getters.getModal;
    }
  }
};
</script>

<style scoped>
</style>

